import { client } from ".";

export const updateProfile = async (
  astrologerId,
  updateFields,
  file,
  accessToken
) => {
  const formData = new FormData();
  formData.append("name", updateFields.name);
  formData.append("description", updateFields.description);
  formData.append("mobile", updateFields.phoneNumber);
  formData.append("email", updateFields.email);
  formData.append("experience", updateFields.experience);
  formData.append("languages", updateFields.languages);
  formData.append("astrologerTypes", JSON.stringify(updateFields.skills));
  formData.append("categories", JSON.stringify(updateFields.expertise));
  formData.append("bankName", updateFields.bankName);
  formData.append("bankAccountNumber", updateFields.bankAccountNumber);
  formData.append("ifscCode", updateFields.ifscCode);
  formData.append("rate", updateFields.rate);
  if (file) {
    formData.append("picture", file);
  }

  try {
    const { data, status } = await client.put(
      `/api/astrologer/update/${astrologerId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    console.log(data);
    return { data, status };
  } catch (err) {
    throw new Error(`Unable to update profile: ${err}`);
  }
};

export const updatePaymentDetails = async (
  astrologerId,
  paymentDetails,
  accessToken
) => {
  try {
    const { data, status } = await client.post(
      `/api/astrologer/payment-details/${astrologerId}`,
      paymentDetails,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return { data, status };
  } catch (err) {
    throw new Error(`Unable to update payment details: ${err}`);
  }
};

export const fetchBankDetails = async (astrologerId, accessToken) => {
  try {
    const { data, status } = await client.get(
      `/api/astrologer/${astrologerId}/payment-details`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return { data, status };
  } catch (err) {
    throw new Error(`Unable to fetch bank details: ${err}`);
  }
};

export const updateBankDetails = async (
  astrologerId,
  bankDetails,
  accessToken
) => {
  try {
    const { data, status } = await client.post(
      `/api/astrologer/${astrologerId}/payment-details`,
      bankDetails,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return { data, status };
  } catch (err) {
    throw new Error(`Unable to update bank details: ${err}`);
  }
};
